// eslint-disable-next-line
/* eslint-disable */
import Vue from 'vue'
import store from '../store'
import router from '../router'
import Base from '../plugins/factory/BaseExtensions'

const authCheck = (toRoute) => {
  return new Promise((resolve, reject) => {
    let authInfo, roleList, entitlementList
    let userInfo = {}
    if (toRoute.meta.authRequired || router.currentRoute.path === '/auth') {
      if (window.location.href.indexOf('auth') === -1) {
        const userData = JSON.parse(localStorage.getItem('userData'))
        console.log(userData, ' == userData')
        //localStorage.setItem('LS_ROUTE_KEY', toRoute.path)
        localStorage.setItem('AUTHENTICATED', false)
        Vue.prototype.$API.covAuth({
          originUri: process.env.ORIGIN_URI,
          authRedirect: window.location.href.split('#')[0] + '#/auth',
          appRedirect: Vue.prototype.$redirectOps
        })
      } else {
        Vue.prototype.$API.handleCovAuthResponse({ selfRedirect: true }).then(res => {
          store.dispatch('userLoggedIn', true)
          authInfo = Vue.prototype.$API.getCovAuthInfo()
          //Vue.prototype.$lasRouteName = localStorage.getItem('LS_ROUTE_KEY')
          if (authInfo.cuid) {
            localStorage.setItem('AUTHENTICATED', true)
            store.dispatch('userLoggedIn', true)
            const promises = [
              Vue.prototype.$API.getPerson({ personId: authInfo.cuid }),
              Vue.prototype.$API.getPersonEntitlements({ personId: authInfo.cuid }),
              Vue.prototype.$API.getPersonRoles({ personId: authInfo.cuid })
            ]
            Promise.all(promises)
              .then(res => {
                userInfo.user = res[0]
                entitlementList = res[1].map(x => x.privilegeName)
                userInfo.entitlementList = entitlementList
                roleList = res[2].map(x => x.name)
                userInfo.roleList = roleList
                if (userInfo.entitlementList.length !== 0 && userInfo.roleList.length !== 0) {
                  store.dispatch('adminLoggedIn', true)
                  localStorage.setItem('isAdmin', true)
                }
                return res;
              }).then(res => {
                Vue.prototype.$API.getOrganizationWithAttributes({ organizationId: res[0].organization.id })
                  .then((res) => {
                    userInfo.organization = res
                    return res;
                  }).then((res) => {
                        Vue.prototype.$API.getOrganizations({data: {'parentOrganization.id': res.id}}).then((res) => {
                          userInfo.homeLocations = res
                          var userLoc = res.length > 0 ? res.map((a) => a.attributes ? a.attributes : []) : [];
                          if(res.length > 0) {
                            userLoc= userLoc.flat(1)
                            userLoc= userLoc.map((a) => a.value);
                          }else {
                            userLoc.unshift(userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value);
                          }               
                          userLoc.unshift("ALL");
                          console.log('userLoc', userLoc)
                          store.commit('SET_HOME_LOCATION_LIST', userLoc.filter(a => a !== undefined))
                          if(userInfo.organization && userInfo.organization.attributes &&  userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO') {
                            store.commit('SET_SELECTED_HOME_LOCATION', 'ALL')
                            store.commit('SET_SELECTED_DASHBOARD_HOME_LOCATION', 'ALL')
                            store.commit('SET_SELECTED_PAIRING_HOME_LOCATION', 'ALL')                            
                          } else{
                            store.commit('SET_SELECTED_HOME_LOCATION', userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value)
                            store.commit('SET_SELECTED_DASHBOARD_HOME_LOCATION', userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value)
                            store.commit('SET_SELECTED_PAIRING_HOME_LOCATION', userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value)
                          }
                          localStorage.setItem('userData', JSON.stringify(userInfo))
                          store.dispatch('setUserInfo', userInfo)
                          if(userInfo.organization && userInfo.organization.attributes &&  userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO') {
                            store.dispatch('getDeviceData', { widget: 'ASSET_COUNT', 'assetType': 'ALL', "userOrgHomeLocation": "ALL" })
                            store.dispatch('getDeviceData', { widget: 'ASSET_TYPE', "userOrgHomeLocation": "ALL" })
                          }else {
                            store.dispatch('getDeviceData', { widget: 'ASSET_COUNT', 'assetType': 'ALL', "userOrgHomeLocation": userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value })
                            store.dispatch('getDeviceData', { widget: 'ASSET_TYPE', "userOrgHomeLocation": userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value })
                          }
                          store.dispatch('getDeviceData', { "widget": "INTERNAL-STATUS_LIST"});
                          resolve(true)
                      }).fail(err => {
                        var userLoc = [];
                        if(userInfo.organization && userInfo.organization.attributes &&  userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO') {
                          userLoc = ["ALL"]
                          store.commit('SET_HOME_LOCATION_LIST', userLoc)
                          store.commit('SET_SELECTED_HOME_LOCATION', "ALL")
                          store.commit('SET_SELECTED_DASHBOARD_HOME_LOCATION', "ALL")
                          store.commit('SET_SELECTED_PAIRING_HOME_LOCATION', "ALL")
                        } else {
                          userLoc = ["ALL", userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value]
                          store.commit('SET_HOME_LOCATION_LIST', userLoc)
                          store.commit('SET_SELECTED_HOME_LOCATION', userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value)
                          store.commit('SET_SELECTED_DASHBOARD_HOME_LOCATION', userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value)
                          store.commit('SET_SELECTED_PAIRING_HOME_LOCATION', userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value)
                        }
                        
                        userInfo.homeLocations = [];                        
                        localStorage.setItem('userData', JSON.stringify(userInfo))
                        store.dispatch('setUserInfo', userInfo)
                        if(userInfo.organization && userInfo.organization.attributes &&  userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO') {
                          store.dispatch('getDeviceData', { widget: 'ASSET_COUNT', 'assetType': 'ALL', "userOrgHomeLocation": "ALL" })
                          store.dispatch('getDeviceData', { widget: 'ASSET_TYPE', "userOrgHomeLocation": "ALL" })
                        }else {
                          store.dispatch('getDeviceData', { widget: 'ASSET_COUNT', 'assetType': 'ALL', "userOrgHomeLocation": userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value })
                          store.dispatch('getDeviceData', { widget: 'ASSET_TYPE', "userOrgHomeLocation": userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value })
                        }
                        resolve(true)
                      })
                  }).fail(err => {
                    store.dispatch('clearUserData')
                    reject(err)
                  })                
              })
              .catch(err => {
                store.dispatch('clearUserData')
                console.log('There was an error in fetcting user\'s granted applications ' + err)
              })
          }
        }).fail(err => {
          store.dispatch('clearUserData')
          reject(err)
        })
      }
    }
  })
}

const signOut = () => {
  var sid = localStorage.getItem("cui.1.sii");
  const url = `${process.env.SERVICE_URL}/p/apiProxy/authn/v4/token/tasks/invalidate`
  fetch(url, {
    headers: {
      'solutioninstanceid': sid,
    }
  })
  localStorage.clear()
  store.dispatch('userLoggedIn', false)
  store.dispatch('clearUserData')
  localStorage.setItem('LS_ROUTE_KEY', '/dashboard')
  Vue.prototype.$lasRouteName = localStorage.getItem('LS_ROUTE_KEY')
  setTimeout(function(){
    router.go('/dashboard')
  }, 600)
}

export default {
  authCheck,
  signOut
}



// WEBPACK FOOTER //
// ./src/plugins/Auth.js